import { Icons } from "./icons";
import { cn } from "@/lib/cn";
import "./control-motion-recipes.css";

/** Keep both icons mounted so quick success/reset changes reverse continuously. */
export function CopyFeedbackIcon({
  copied,
  className,
}: {
  copied: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn("denker-copy-feedback", className)}
      data-copied={String(copied)}
      aria-hidden="true"
    >
      <span>
        <Icons.Copy className="h-full w-full" />
      </span>
      <span>
        <Icons.Check className="h-full w-full" />
      </span>
    </span>
  );
}
